import Vue from 'vue'
import { Component, Prop, Watch } from 'vue-property-decorator'
import WriteBody from '@calendar/components/Write/WriteBody.vue'
import * as dateutil from '@/util/date-helper'
import { mapGetters } from 'vuex'
import * as types from '@calendar/store/types'
@Component({
    components: {
        WriteBody
    },
    computed: {
        ...mapGetters({
            folderListTree: types.FOLDER_LIST_TREE
        })
    }
})
export default class ReadForm extends Vue {
    //
    // ────────────────────────────────────────────────── I ──────────
    //   :::::: P R O P S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────
    //

    @Prop({ type: Object }) item!: calendar.CalendarItem
    @Prop({ type: Object }) conference!: any

    //
    // ────────────────────────────────────────────────────── I ──────────
    //   :::::: G E T T E R S : :  :   :    :     :        :          :
    // ────────────────────────────────────────────────────────────────
    //

    folderListTree!: any

    //
    // ──────────────────────────────────────────────── I ──────────
    //   :::::: D A T A : :  :   :    :     :        :          :
    // ──────────────────────────────────────────────────────────
    //

    accepted: boolean = false // 모임 참석 수락함
    declined: boolean = false // 모임 참석 거절함

    //
    // ──────────────────────────────────────────────────────── I ──────────
    //   :::::: C O M P U T E D : :  :   :    :     :        :          :
    // ──────────────────────────────────────────────────────────────────
    //

    get conferenceText() {
        if (this.conference) {
            return this.conference.groupDisplayName + ' > ' + this.conference.displayName
        } else {
            return null
        }
    }

    get startDateText() {
        return dateutil.uGetDateFormat('yyyy-mm-dd', dateutil.IEDate(this.item.start)); 
    }

    get endDateText() {
        return dateutil.uGetDateFormat('yyyy-mm-dd', dateutil.IEDate(this.item.end)); 
    }

    get reminderText() {
        var number = this.item.reminderMinutesBeforeStart || 0
        if(number === 60) {
            return this.$t('N시간_전_알림', {number: 1}).toString()
        }
        else if(number === 1440) {
            return this.$t('N일_전_알림', {number: 1}).toString()
        }
        else if(number === 2880) {
            return this.$t('N일_전_알림', {number: 2}).toString()
        }
        else if(number === 4320) {
            return this.$t('N일_전_알림', {number: 3}).toString()
        }
        else if(number < 60) {
            return this.$t('N분_전_알림', {number: number}).toString()
        }
    }

    get folderText() {
        var text = '폴더'
        if (this.item.parentId) {
            var displayName = this.folderListTree.mylist.items.filter((x: any) => x.id  == this.item.parentId)[0]?.displayName
            text = displayName ? displayName : ''
        }
        return text
    }

    /**
     * 반복일정 설정 내용을 표시합니다
     */
    get getRecurrencePatternDisplay() {
        let beautifyStartTime
        let beautifyEndTime

        if (this.item.starttime && this.item.starttime.length > 3) {
            beautifyStartTime = this.item.starttime.substr(0, this.item.starttime.length - 3)
        }
        if (this.item.endtime && this.item.endtime.length > 3) {
            beautifyEndTime = this.item.endtime.substr(0, this.item.endtime.length - 3)
        }

        let display: string = ''
        //ex) 기간 3일 : 3.00:00:00 -> 3
        let scheduleDuration = this.item.scheduleDuration.split('.')[0]

        if (
            false &&
            this.item.isRecurring.toString() === 'False' &&
            this.item.appointmentType != 'RecurringMaster'
        ) {
            return (display = this.item.pidLidRecurrencePattern)
        }

        if (
            this.item.isRecurring.toString() === 'True' ||
            this.item.appointmentType == 'RecurringMaster'
        ) {
            if (this.item.appointmentType == 'Occurrence' || this.item.appointmentType == 'Exception') {
                display = this.item.pidLidRecurrencePattern
            }
            //'전체약속'
            else {
                let beautifyStartDate = this.item.recurrence.startDate.split('T')[0]
                let beautifyEndDate
                if (this.item.recurrence.endDate != null) {
                    beautifyEndDate = this.item.recurrence.endDate.split('T')[0]
                }
                //매일
                if (this.item.recurrence.ui_recurringType == 1) {
                    if (this.item.recurrence.endDate != null) {
                        display = `${beautifyStartDate} 부터 ${beautifyEndDate} 까지 매 ${this.item.recurrence.interval}일씩 주기로 ${beautifyStartTime} - ${beautifyEndTime}에 반복`
                    } else {
                        display = `${beautifyStartDate} 부터 매 ${this.item.recurrence.interval}일씩 주기로 ${beautifyStartTime} - ${beautifyEndTime}에 반복`
                    }
                }
                //매주
                else if (this.item.recurrence.ui_recurringType == 2) {
                    let weeklist = dateutil.uGetWeekArray([
                        this.$t('W_Schedule_Sunday').toString(),
                        this.$t('W_Schedule_Monday').toString(),
                        this.$t('W_Schedule_Tuesday').toString(),
                        this.$t('W_Schedule_Wednesday').toString(),
                        this.$t('W_Schedule_Thursday').toString(),
                        this.$t('W_Schedule_Friday').toString(),
                        this.$t('W_Schedule_Saturday').toString(),
                    ])
                // 반복일정 수정할 때 요일 체크한거 화면에 display
                let weekArrayString = weeklist
                    .filter((x: any) => this.item.recurrence.daysOfTheWeekArray?.indexOf(x.value) != -1)
                    .map((x) => {
                    return x.text
                    })
                    .join(',')
                    if (this.item.recurrence.endDate != null) {
                        display = `${beautifyStartDate} 부터 ${beautifyEndDate} 까지 매${this.item.recurrence.interval}주마다 ${weekArrayString} ${beautifyStartTime} - ${beautifyEndTime}에 반복`
                    } else {
                        display = `${beautifyStartDate} 부터 매${this.item.recurrence.interval}주마다 ${weekArrayString} ${beautifyStartTime} - ${beautifyEndTime}에 반복`
                    }
                }
                //매월
                else if (this.item.recurrence.ui_recurringType == 3) {
                    if (this.item.recurrence.endDate != null) {
                        display = `${beautifyStartDate} 부터 ${beautifyEndDate} 까지 매월 ${this.item.recurrence.interval}개월마다 ${this.item.recurrence.dayOfMonth}일에 ${beautifyStartTime} - ${beautifyEndTime}에 반복`
                    } else {
                        display = `${beautifyStartDate} 부터 매월 ${this.item.recurrence.interval}개월마다 ${this.item.recurrence.dayOfMonth}일에 ${beautifyStartTime} - ${beautifyEndTime}에 반복`
                    }
                }
                //매년
                else if (this.item.recurrence.ui_recurringType == 4) {
                    if (this.item.recurrence.endDate != null) {
                        display = `${beautifyStartDate} 부터 ${beautifyEndDate} 까지 매년 ${this.item.recurrence.monthValue}월 ${this.item.recurrence.dayOfMonth}일마다 ${beautifyStartTime} - ${beautifyEndTime}에 반복`
                    } else {
                        display = `${beautifyStartDate} 부터 매년 ${this.item.recurrence.monthValue}월 ${this.item.recurrence.dayOfMonth}일마다 ${beautifyStartTime} - ${beautifyEndTime}에 반복`
                    }
                }
            }
        }
        if (!this.item.isEWS) {
            this.item.pidLidRecurrencePattern = display
        }
        return display
    }

}